import React from 'react'
import IframeSocialMedia from '../Package/IframeSocialMedia'

function SocialLinks() {
  return (
      <>
          {/* #Social Media */}
          <section className="journey section" id="journey" aria-label="journey">
              <div className="container" style={{ marginTop: '15px' }}>
                  <IframeSocialMedia />
              </div>
          </section>
      </>
  )
}

export default SocialLinks